import { stammdatenService } from './StammdatenService.js';
import { zeigeKleineNachricht } from '../systemNachricht.js';

/**
 * Frontend-Service für Events (Bedarfsplaner) — siehe reference/bedarfsplaner/BEDARFSPLANER.md §5.
 */
class EventService {
	/**
	 * Holt alle Events, die sich mit dem Zeitraum überschneiden.
	 * @param {dayjs} startDatum
	 * @param {dayjs} endDatum
	 */
	async holeEventsZeitraum(startDatum, endDatum) {
		try {
			const urlParams = new URLSearchParams({
				StartDatum: startDatum.format('YYYY-MM-DD'),
				EndDatum: endDatum.format('YYYY-MM-DD'),
				BetriebsstaetteID: stammdatenService.aktuelleBetriebsstaette,
			});
			const response = await fetch(`/dienstplan/api/events?${urlParams.toString()}`);
			if (!response.ok) {
				return [];
			}
			return await response.json();
		} catch (error) {
			console.log(error);
			return [];
		}
	}

	/**
	 * Bereits verwendete Eigene-Felder-Namen (Vorschlags-Chips im Editor).
	 */
	async holeDetailsVorschlaege() {
		try {
			const response = await fetch(`/dienstplan/api/events/details-vorschlaege?BetriebsstaetteID=${stammdatenService.aktuelleBetriebsstaette}`);
			if (!response.ok) {
				return [];
			}
			return await response.json();
		} catch (error) {
			console.log(error);
			return [];
		}
	}

	/**
	 * Speichert eine Event samt ihrer Bedarfszeilen. Neu (kein _id) → POST, sonst PUT.
	 * @param {object} event
	 * @param {array<object>} bedarfZeilen
	 * @param {boolean} [schichtenLoeschen] zugeordnete Schichten entfernter Zeilen mitlöschen (bestätigt)
	 * @returns {Promise<object|false>} bei PUT inkl. `SchichtenBericht`
	 */
	async speichereEvent(event, bedarfZeilen, schichtenLoeschen = false) {
		try {
			const istNeu = !event._id;
			const url = istNeu ? '/dienstplan/api/events' : `/dienstplan/api/events/${event._id}`;
			const response = await fetch(url, {
				method: istNeu ? 'POST' : 'PUT',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(istNeu ? { event, bedarfZeilen } : { event, bedarfZeilen, schichtenLoeschen }),
			});
			if (!response.ok) {
				const message = await response.text();
				zeigeKleineNachricht(message, 0);
				return false;
			}
			zeigeKleineNachricht('Event gespeichert!', 1);
			return await response.json();
		} catch (error) {
			console.log(error);
			zeigeKleineNachricht('Speichern fehlgeschlagen!', -1);
			return false;
		}
	}

	/**
	 * @param {string} eventID
	 * @param {boolean} [schichtenLoeschen] zugeordnete Schichten mitlöschen (bestätigt)
	 */
	async entferneEvent(eventID, schichtenLoeschen = false) {
		try {
			const response = await fetch(`/dienstplan/api/events/${eventID}${schichtenLoeschen ? '?schichtenLoeschen=true' : ''}`, { method: 'DELETE' });
			if (!response.ok) {
				const message = await response.text();
				zeigeKleineNachricht(message, 0);
				return false;
			}
			zeigeKleineNachricht('Event gelöscht!', 1);
			return true;
		} catch (error) {
			console.log(error);
			zeigeKleineNachricht('Löschen fehlgeschlagen!', -1);
			return false;
		}
	}
}

const eventService = new EventService();
export { eventService };
